export default __webpack_public_path__ + "static/media/facebook-connect.4939267c.jpg";